




















import Vue from 'vue';
import { Component,Watch } from 'vue-property-decorator';
import ruleDialog from '@/components/dialog/rule/index'
import loginDialog from '@/components/dialog/login/index'
import questionDialog from '@/components/dialog/question/index.vue'
import shareDialog from '@/components/dialog/share/index'
import { goUrl } from "@/utils/hybird"
import appointDialog from '@/components/dialog/submit/index'
import appoint from '@/views/home/components/Appoint.vue'
import UserShow from './components/UserShow.vue'
import DriverPoint from './components/DriverPoint.vue'
let getOffset: any = function (dom: any, offset = { left: 0, top: 0 }) {
  if (dom.nodeName === "BODY") {
    return offset;
  }
  const l = dom.offsetLeft;
  const t = dom.offsetTop;
  offset.left += l;
  offset.top += t;
  return getOffset(dom.offsetParent, offset);
};
@Component({
    components:{
        questionDialog,
        appoint,
        UserShow,
        DriverPoint
    }
})
export default class Home extends Vue {
    public discount:boolean = false;
    public hasClick:boolean = false;
    public commitContent:string = '';
    public uname:string = '';
    public showSlogon:boolean = true;
    public mounted() {
        let id = this.$route.query.id;
        if (id) {
            let top = getOffset(this.$refs.appointComp).top;
            console.log(top)
            this.scrollToTarget(top);
        }
    }
    public scrollToTarget(targetTop: number) {
      let container = (document as any).getElementById("app");
      let timer: number = setInterval(() => {
        let speed = Math.ceil((targetTop - container.scrollTop) / 6);
        if (speed == 0) {
          clearInterval(timer);
          timer = 0;
        } else {
          container.scrollTop = container.scrollTop + speed;
        }
      }, 1000 / 60);
    }
    public showRule(){
        window._hmt.push(["_trackPageview", "/#/activityRule"]);
        ruleDialog();
    }
    jumpUrl(){
        window._hmt.push(["_trackPageview", "/#/annualAccount"]);
        this.$router.push({
            path:'/annualAccount'
        })
    }
    goAppoint(){
        appointDialog({
            uname:this.uname
        });
    }

    public goUrl(url:any,linkId:any){
        goUrl(url,linkId)
    }
    
    /**
     * 获取用户信息
     */
    public async queryAnswer() {
        const res = (await this.request.get('/peugeot/queryAnswer')) as any;
        // if(res.code!=200){
        //     this.commit('SET_LOGINSTATE',false);
        // }else{
        //     this.commit('SET_LOGINSTATE',true);
        // }
        return new Promise((resolve)=>{
            if(res.code!=200){
                this.commit('SET_LOGINSTATE',false);
            }else{
                this.commit('SET_LOGINSTATE',true);
                this.commit('SET_NICK',res.data.uname);
                this.commitContent = res.data.commitContent;
                this.uname = res.data.uname;
            }
            resolve(res.data)
        })
    }

    public get request(){
        return (this as any).$axios
    }
    public get commit(){
        return (this as any).$store.commit
    }
    public goToTest(){
        if(this.$store.state.loginState==false){
            loginDialog({
                callback:()=>{
                    this.queryAnswer().then((data:any)=>{
                        this.showSlogon = false;
                        this.hasClick = true;
                    });
                }
            });
        }else{
            this.showSlogon = false;
            this.hasClick = true;
        }
    }
}
